import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const updateLeague=(id,name,token)=>async dispatch=>{
    dispatch({
        type:actionTypes.UPDATE_LEAGUE_START
    })
    const options={
        url:`${api}/leagues/${id}`,
        method:'PUT',
        headers:{
            'Authorization':`Bearer ${token}`
        },
        data:{name}
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.UPDATE_LEAGUE_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.UPDATE_LEAGUE_FAIL,
                payload:getMessage(error)
            }))
}